export default (data) => ({
  type: 'OPEN_SIDEBAR_FILTER',
  payload: data,
});
